import {
  listUrbanChicLadiesColors,
  listUrbanChicGentsColors
} from '../utils/bike-schema'
import { fontColorForBackground } from '../utils/colors'
import { formatCurrencyAlwaysSign } from '../utils/money'
import { t } from '../utils/i18n'

const getListColors = (baseModelId) =>
  baseModelId.endsWith('chic-gents') || baseModelId.endsWith('chic-top-gents')
    ? listUrbanChicGentsColors()
    : listUrbanChicLadiesColors()

const RalPickerUrban = ({
  activeRal,
  priceDiffForRal,
  currencyCode,
  onSelect,
  baseModelId
}) => {
  const listColors = getListColors(baseModelId)
  return (
    <div className="velorbis-customizer-ral-picker">
      <div
        className="velorbis-customizer-ral-picker-colors"
        ref={(el) => (this.colorsEl = el)}
      >
        {listColors.map(({ ral, hex, name }) => {
          const priceDiff = priceDiffForRal ? priceDiffForRal(ral) : 0
          return (
            <div
              key={ral}
              className="velorbis-customizer-ral-picker-color"
              style={{
                backgroundColor: hex,
                color: fontColorForBackground(hex)
              }}
              data-ral={ral}
              onClick={() => onSelect(ral)}
            >
              <div className="velorbis-customizer-ral-picker-color-name">
                RAL {ral}: {name}
                {priceDiff !== 0 && (
                  <span className="velorbis-customizer-ral-picker-color-price">
                    {' '}
                    {formatCurrencyAlwaysSign(priceDiff, currencyCode)}
                  </span>
                )}
                {activeRal == ral && (
                  <div className="velorbis-customizer-ral-picker-color-selected">
                    {t('selected')}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default RalPickerUrban
